import { Component, OnInit } from '@angular/core';
import { AlertController, ModalController, NavController, ToastController } from '@ionic/angular';
import { FormBuilder } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { UtilService } from '../../../service/util.service';
import { UserProfile } from '../../../models/user-profile.model';
import { CounterService } from '../counter.service';
import { MstCounter } from '../../../models/mst-counter.model';
import { RoleAccess } from '../../../models/role-access.model';
import { Router } from '@angular/router';
import { UserData } from '../../../providers/user-data';
import { SearchUserComponent } from '../../../component/search-user/search-user.component';
import { IonicSelectableComponent } from 'ionic-selectable';

class User {
  public id: string;
  public name: string;
}

@Component({
  selector: 'app-counter-create',
  templateUrl: './counter-create.page.html',
  styleUrls: ['./counter-create.page.scss'],
})
export class CounterCreatePage implements OnInit {
  token: any;
  branchList: any[] = [];
  userProfile: UserProfile = new UserProfile();
  roleAccess = new RoleAccess();
  searchValue: any[] = [];
  counterShapeList:any[]=[];
  locationList:any[]=[];
  branchId:number=0;  
  shapeId:any;
  locationId:any;
  coordinatorId:any='';
  coordinatorName:any='';
  assistantManagerId:any = 0;
  assistantManagerName:any ='';
  spgId:any[]=[];
  spgName:any[]=[];
  jumlahSpg:number=0;
  counterCode:any='';
  counterName:any='';
  transDate:any='';
  firstAddress:any='';
  lastAddress:any='';
  phone:number=0;
  footerText:any='';
  timezone:any='';
  luas:any;
  tipe:any;
  bentuk:any;
  meja_highlight:number=0;
  meja_promo:number=0;
  jumlah_backwall:number=0;
  ops_by:any;
  pic:any;
  sharing_margin:any;
  konsi_or_non:any;
  sistem_kerjasama:any;
  biaya_sewa:any;
  periode_sewa:any;

  selectedBranchs:any ='';
  selectedShapes:any='';
  selectedLocations:any='';
  selectedAssistantManagers:any='';
  selectedCoordinators:any='';
  userList:any[]=[];
  printer_type:any='';
  print_amount:number=0;
  prefix_pr:any='PR';
  prefix_rg:any='RG';
  company:any='VCI';

  constructor(
    private fb: FormBuilder,
    private storage: Storage,
    private utilService: UtilService,
    private alertController: AlertController,
    private toastCtrl: ToastController,
    private navCtrl: NavController,
    private counterService: CounterService,
    private userData: UserData,
    private router: Router,
    private modalController:ModalController
  ) { }

  ngOnInit() {

    Promise.all([
      this.storage.get('user_token'),
      this.storage.get('user_profile'),
      this.storage.get('user_menu_access')
    ])
    .then(([token, profile, access]) => {
      if(token) {
        this.token = token;        
        this.roleAccess = this.userData.checkAccess(this.router.url, access, this.userProfile);
        if(!this.roleAccess || this.roleAccess.update!='1'){
          this.toastCtrl.create({ duration: 2000, message: 'You Are Not Allowed to Access this Page' }).then(t => t.present());
          this.navCtrl.navigateForward(['/']);
        }
        else{
          this.utilService.loadingPresent('Harap tunggu...')
          .then(() => {
            this.userProfile = new UserProfile(profile);
            this.counterService.getCounterforCreate({ "token": this.token }).subscribe((response) => {
              this.utilService.loadingDismiss();
              this.branchList = response.results.branch_data;
              this.userList = response.results.user_data;
              this.counterShapeList = response.results.counter_shape_data;
              this.locationList = response.results.counter_location_data;
            });
          });
        }
      }
    });
  }

  formValidation(){
    let error:number=0;
    let message =' Required :';
    if(this.branchId==0){
      message+='Branch,';
      error++;
    }
    if(this.counterCode==''){
      message+='Counter Code,';
      error++;
    }
    if(this.counterName==''){
      message+='Counter Name,';
      error++;
    }
    if(this.transDate==''){
      message+='Trans Date,';
      error++;
    }
    if(this.firstAddress==''){
      message+='Address 1,';          
      error++;
    }
    if(this.lastAddress==''){
      message+='Address 2,';
      error++;
    }
    if(this.footerText==''){
      message+='Footer Text,';
      error++;
    }
    if(this.phone==0){
      message+='Phone,';
      error++;
    }
    if(this.timezone==''){
      message+='Timezone,';
      error++;
    }
    if(this.printer_type==''){
      message+='Printer Type,';
      error++;
    }
    if(this.print_amount<1){
      message+='Print Amount,';
      error++;
    }
    if(error==0){
      this.inputCounter();
    }
    else{
      this.toastCtrl.create({ duration: 2000, message: message }).then(t => t.present());
    }
  }

  inputCounter() {

    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      let dateConvert = this.utilService.convertDate(this.transDate);
      let newTransDate = dateConvert.years + '-' + dateConvert.months + '-' + dateConvert.dates;
      let getDatePeriodStock = new Date(new Date(newTransDate).getFullYear(), new Date().getMonth() + 1, 0);
      let periodConvert = this.utilService.convertDate(getDatePeriodStock);
      let periodStock = periodConvert.years + '-' + periodConvert.months + '-' + periodConvert.dates;
      let daftarSpg = '';
      for(let i=0;i<this.spgId.length;i++){
        if(this.spgId[i]!='0'){
          daftarSpg += this.spgId[i]+',';
        }
      }
      daftarSpg = daftarSpg.replace(/(^,)|(,$)/g, "");
      let detail ={
        'branch_id' :this.branchId,
        'counter_code' :this.counterCode,
        'counter_name' :this.counterName,
        'trans_date' :newTransDate,
        'stock_period' :periodStock,
        'first_address' :this.firstAddress,
        'last_address' :this.lastAddress,
        'phone' :this.phone,
        'footer_text' :this.footerText,
        'timezone' :this.timezone,
        'created_by' :this.userProfile.username,
        'luas' : this.luas,
        'tipe' : this.tipe,
        'bentuk' : this.shapeId,
        'meja_highlight' : this.meja_highlight,
        'meja_promo' : this.meja_promo,
        'jumlah_backwall' : this.jumlah_backwall,
        'ops_by' : this.ops_by,
        'pic' : this.pic,
        'sharing_margin':this.sharing_margin,
        'konsi_or_non':this.konsi_or_non,
        'sistem_kerjasama' : this.sistem_kerjasama,
        'biaya_sewa':this.biaya_sewa,
        'periode_sewa':this.periode_sewa,
        'location':this.locationId,
        'assistant_manager':this.assistantManagerId,
        'coordinator':this.coordinatorId,
        'jumlah_spg':this.jumlahSpg,
        'daftar_spg':daftarSpg,
        'printer_type':this.printer_type,
        'print_amount':this.print_amount,
        'company':this.company
        //'prefix_pr':this.prefix_pr,
        //'prefix_rg':this.prefix_rg
      }
      this.counterService.addCounter(detail).subscribe((response) => {
        this.utilService.loadingDismiss();
        if(response.status.code === 201) {
          this.showConfirmInput();
        } else {
          this.toastCtrl.create({ duration: 2000, message: 'Terdapat Error' }).then(t => t.present());
        }
      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      })
    });
  }

  async showConfirmInput() {
    const alert = await this.alertController.create({
      header: 'Notification',
      cssClass:'custom-alert-class',
      message: 'Data sudah tersimpan!',
      buttons: [
        {
          text: 'OK',
          handler: () => {
            this.navCtrl.navigateForward(['/counter']);;
          }
        }
      ]
    });

    await alert.present();
  }
  
  selectBranch(event){
    this.branchId = event.value.id;
  }

  selectShape(event){
    this.shapeId = event.value.id;
  }

  selectLocation(event){
    this.locationId = event.value.id;
  }
  
  searchUser(event: {
    component: IonicSelectableComponent,
    text: string
  }, index: any) {
    let text: string;

    if(this.searchValue.length > 0) {
      text = this.searchValue[index] ? this.searchValue[index] : '';
    }

    text = event.text !== '' ? event.text.trim().toLowerCase() : '';
    event.component.startSearch();

    if (!text) {
      event.component.items = [];
      event.component.endSearch();
      return;
    }

    event.component.items = this.filterProducts(this.userList, text);
    this.searchValue[index] = text;
    event.component.endSearch();
  }

  filterProducts(products: User[], text: string) {
    return products.filter(product => {
      return product.name.toLowerCase().indexOf(text) !== -1 ||
        product.id.toString().toLowerCase().indexOf(text) !== -1;
    });
  }

  createSpg(){
    this.spgId=[];
    for(let i=0;i< (this.jumlahSpg);i++){
      this.spgId.push(0);
      this.spgName.push('');
    }
  }
   
  async openSearchUser(type:any,no:number) {
    const modal = await this.modalController.create({
      component: SearchUserComponent,
      componentProps: {
        "counterId": this.userProfile.counter_id_pos ? this.userProfile.counter_id_pos : 0,
        'token': this.token,
        'listUser':this.userList
      },
      backdropDismiss: false
    });

    modal.onDidDismiss().then((modelData) => {
      console.log(modelData);
      if (modelData !== null && modelData.data!= undefined) {
        if(type=='co'){
          this.coordinatorId = (modelData.data.userId);
          this.coordinatorName = (modelData.data.name);
        }
        else if(type=='am'){
          this.assistantManagerId = (modelData.data.userId);
          this.assistantManagerName = (modelData.data.name);
        }
        else if(type=='spg'){
          this.spgId[no]=(modelData.data.userId);
          this.spgName[no]=(modelData.data.name);
        }
      }
    });

    return await modal.present();
  }

  removeCoordinator(){
    this.coordinatorId = 0;
    this.coordinatorName ='';
  }
  
  removeAssistantManager(){
    this.assistantManagerId = 0;
    this.assistantManagerName ='';
  }
  removeSpg(i:number){
    this.spgId[i] = 0;
    this.spgName[i] ='';
  }

}
